import React, { useEffect, useState } from 'react';
import "./ScheduleTable.scss"
import { useSelector } from 'react-redux';
import { createMonthsColumns } from '../../../helpers/table';
import ScheduleColumn from '../ScheduleColumn/ScheduleColumn';
import ClinicsColumn from '../ClinicsColumn/ClinicsColumn';

const ScheduleTable = ({ specialists, salons, slots, currentSchedule, underfilledSlots, ref }) => {
    const period = useSelector(state => state.schedule.period);

    const [columns, setColumns] = useState([]);

    useEffect(() => {
        setColumns(createMonthsColumns(period))
    }, [])

    useEffect(() => {
        setColumns(createMonthsColumns(period))
    }, [period])
    
    const selectSlotsAction = (id, isHover) => () => {
        const salonElements = document.querySelectorAll(`[data-specialist-id="${id}"]`);
        
        if (isHover) {
            for (let i = 0; i < salonElements.length; i++) {
                salonElements[i].classList.add("hovered");
            }
        } else {
            for (let i = 0; i < salonElements.length; i++) {
                salonElements[i].classList.remove("hovered");
            }
        }
    };

    const rowHoverAction = (id, isHover) => () => {
        const rowElements = document.querySelectorAll(`[data-row-id="${id}"]`);
        
        if (isHover) {
            for (let i = 0; i < rowElements.length; i++) {
                rowElements[i].classList.add("selected");
            }
        } else {
            for (let i = 0; i < rowElements.length; i++) {
                rowElements[i].classList.remove("selected");
            }
        }
    };

    return (
        <div className="schedule-table" ref={ref}>
            <div className="schedule-table__inner">
                <ClinicsColumn salons={salons} rowHoverAction={rowHoverAction} />
                {columns.map((column, index) => {
                    return (
                        <ScheduleColumn
                            element={column}
                            warningSlots={underfilledSlots[column.customDate]}
                            specialists={specialists}
                            salons={salons}
                            slots={slots}
                            currentSchedule={currentSchedule}
                            underfilledSlots={underfilledSlots}
                            key={index}
                            selectSlotsAction={selectSlotsAction}
                        />
                    )
                })}
            </div>
        </div>
    );
};

export default ScheduleTable;